import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import AzureFilesUploader, {
  AzureFilesUploaderProps,
} from './AzureFilesUploader';
import { useTranslation } from 'react-i18next';

export type AzureFilesUploaderControlledProps<
  T extends FieldValues = FieldValues
> = UseControllerProps<T> & AzureFilesUploaderProps;

/**
 * Basado en código de https://github.com/react-hook-form/react-hook-form/discussions/2146#discussioncomment-579355
 */
export function AzureFilesUploaderControlled<
  T extends FieldValues = FieldValues
>(props: AzureFilesUploaderControlledProps<T>) {
  const {
    btnText,
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
    label,
    ...dropZoneOptions
  } = props;

  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      rules={rules}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      control={control}
      render={({ field, fieldState }) => (
        <AzureFilesUploader
          btnText={btnText ?? t('common:actions.uploadFile')}
          {...dropZoneOptions}
          label={label}
          name={field.name}
          error={fieldState.error?.message}
          onUploaded={field.onChange}
          onTrash={() => field.onChange(null)}
          value={field.value}
        />
      )}
    />
  );
}
